module.exports = __webpack_public_path__ + "img/smile.c441c54a.png";